import { Component, Input, QueryList, ViewChildren } from '@angular/core';
import { MemberappBaseComponent } from '../groupportal-base/groupportal-base.component';
import { MatDatepicker } from '@angular/material/datepicker';
import { Subscription } from 'rxjs';
import { defaultMemberEndDate } from '../../../../environments/environment.base';
import * as moment from 'moment';

@Component({
	selector: 'app-residency-details',
	templateUrl: './residency-details.component.html',
	styleUrls: ['./residency-details.component.scss']
})
export class ResidencyDetailsComponent extends MemberappBaseComponent {
	@Input() selectedContactDetails: any;
	@Input() formSubmitted: boolean;
	@Input() ui_Residencies: any;
	@Input() ui_Specialities: any;
	@ViewChildren(MatDatepicker) datepickers: QueryList<MatDatepicker<Date>>;

	showTypeaheadOptions = false;
	showTypeaheadOptionSpecialities = false;
	filteredResidencies = [];
	filteredSpecialities = [];
	selectedResidency: string = '';
	selectedSpeciality: string = '';
	selectedGradYear: string = '';
	disableResidency: boolean = false;
	disableSpeciality: boolean = false;
	disableGradYear: boolean = false;
	USA_EM_Specialities = ['EM', 'EMANES', 'EMIM', 'FMEM', 'PEM'];

	subscriptions: Array<Subscription> = [];

	ngAfterViewInit() {
		console.log('ngAfterViewInit Method called from Residency Details');

		this.datepickers.forEach(datepicker => {
			let gradYearSubscription: Subscription =  datepicker.openedStream.subscribe(() => {
				setTimeout(() => {
						const calendarButton = document.querySelector('.mat-focus-indicator.mat-calendar-period-button.mat-button.mat-button-base') as HTMLElement;

						if (calendarButton) {
							calendarButton.style.pointerEvents = 'none';
							calendarButton.setAttribute('disabled', 'true')
						}
				});
			});
			this.subscriptions.push(gradYearSubscription);
		});

		
	}

	onResidencyInput(query: string): void {
		if (query.trim().length >= 3) {
			// Filter items that match the query
			const matchingResidencies = this.ui_Residencies.filter(residency =>
				residency.name.toLowerCase().includes(query.toLowerCase()) && residency.isEM == 1
			);

			// Find the specific item in ui_Residencies
			const specificItem = this.ui_Residencies.find(residency =>
				residency.acep_code !== null && residency.acep_code?.toLowerCase() === 'manual');

			// If the specific item exists and is not in the filtered list, add it to the end
			if (specificItem && !matchingResidencies.includes(specificItem)) {
				matchingResidencies.push(specificItem);
			}
			this.filteredResidencies = matchingResidencies;
			this.showTypeaheadOptions = this.filteredResidencies.length > 0;
		} else {
			this.showTypeaheadOptions = false;
		}
	}

	selectResidency(residency: string, residencySpecialitycode: string, residencyId: string): void {
		if (residencySpecialitycode !== null && residencySpecialitycode?.toLowerCase() === 'manual') {
			this.selectedContactDetails.residency.id = '';
			this.selectedResidency = '';
			this.sideNavService.setInvalidResidency$.next(true);	
		}
		else {
			this.selectedContactDetails.residency.id = residencyId;
			this.selectedResidency = residency; 
		}
		this.showTypeaheadOptions = false;
	}

	onSpecialityInput(query: string): void {
		if (query.trim().length >= 3) {
			// Filter items that match the query
			const matchingSpecialities = this.ui_Specialities.filter(speciality =>
				speciality.acep_name.toLowerCase().includes(query.toLowerCase())
			);

			// const matchingSpecialities = this.ui_Specialities.filter(speciality =>
			// 	 this.USA_EM_Specialities.includes(speciality.acep_code)
			// );

			this.filteredSpecialities = matchingSpecialities;

			this.showTypeaheadOptionSpecialities = this.filteredSpecialities.length > 0;
		} else {
			this.showTypeaheadOptionSpecialities = false;
		}
	}

	selectSpeciality(speciality: string, residencySpecialitycode: string, residencySpecialtyId: string): void {
		const isSpecialityValid = this.USA_EM_Specialities.includes(residencySpecialitycode)

		if (isSpecialityValid) {
			this.selectedContactDetails.residency.specialityId = residencySpecialtyId;
			this.selectedSpeciality = speciality;
		}
		else {
			this.selectedContactDetails.residency.specialityId = '';
			this.selectedSpeciality = '';
			this.sideNavService.setInvalidResidency$.next(true);
		}
		this.showTypeaheadOptionSpecialities = false;
	}

	handleYearSelected(selectedYear: moment.Moment, datepicker: MatDatepicker<any>, ) 
	{
		this.selectedGradYear = this.getFullGradDate(selectedYear);
		datepicker.close();
	}

	getFullGradDate(selectedYear: string | moment.Moment) {
		let yearString: string;
	  
		if (typeof selectedYear === 'string') 
		{
		  yearString = selectedYear;
		} 
		else if (moment.isMoment(selectedYear)) 
		{
		  yearString = selectedYear.year().toString();
		  this.selectedContactDetails.residency.gradYear = yearString;
		} 
		else 
		{
		  // Handle other cases or throw an error if needed
		  throw new Error('Invalid type for selectedYear');
		}
	  
		// Construct the full date string and format it
		const endDateString = `${defaultMemberEndDate}${yearString}`;
		const fullGradDate = moment(endDateString).format('YYYY-MM-DD');
		
		return fullGradDate;
	  }

	onDatePickerClosed() {
		this.disableGradYear = false;
	}
	
	setResidency(acepId) {
		console.log('setResidency Method called from Side Nav');
	
		if (acepId === 0 || acepId !== this.selectedContactDetails.ACEPID) {
			this.disableResidency = false;
			this.disableSpeciality = false;
			this.disableGradYear = false;
			this.selectedResidency = '';
			this.selectedSpeciality = '';
			this.selectedGradYear = '';
			return;
		}
	
		this.selectedResidency = this.getResidency(this.selectedContactDetails.residency.id);
		this.disableResidency = this.selectedResidency !== '';
	
		this.sideNavService.setInvalidResidency$.next(false);
	
		this.selectedSpeciality = this.getSpeciality(this.selectedContactDetails.residency.specialityId);
		this.disableSpeciality = this.selectedSpeciality !== '';
	
		this.selectedContactDetails.residency.gradYear = this.selectedContactDetails.residency.gradYear;
		if(this.selectedContactDetails.residency.gradYear.length > 1)
		{
			this.selectedGradYear = this.getFullGradDate(this.selectedContactDetails.residency.gradYear);
			this.disableGradYear = true;
		}
		else{
			this.selectedGradYear = '';
			this.disableGradYear = false;
		}
	}
	

	getResidency(id) {
		const filterResidency = this.ui_Residencies.find(residency => residency.accountId === id);
		return filterResidency ? filterResidency.name : '';
	}
	
	getSpeciality(id) {
		const filterSpeciality = this.ui_Specialities.find(speciality => speciality.id === id);
		return filterSpeciality ? filterSpeciality.acep_name : '';
	}
	

	ngOnDestroy() {
		// unsubscribe to ensure no memory leaks
		this.subscriptions.forEach((subscription: Subscription) => {
		  subscription.unsubscribe();
		});
	  }
}
